import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/apps/kiosk/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/kiosk/src/Layout/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@mui/material-nextjs/v13-appRouter/index.js");
